import { Col, Container, Row } from 'react-bootstrap';
import AppHeader from '../../components/AppHeader';
import Loader from '../../components/Loader';
import NoData from '../../components/NoData';
import OpacityAnimation from '../../components/OpacityAnimation';
import Sidebar from '../../components/Sidebar';
import useGetGeneralAppData from '../../hooks/useGetGeneralAppData';
import BillingAddressCard from './components/BillingAddressCard';
import CompanyAddressCard from './components/CompanyAddressCard';
import ContactDataCard from './components/ContactDataCard';
import EditModal from './components/EditModal';
import GeneralDataCard from './components/GeneralDataCard';
import Header from './components/Header';
import LockModal from './components/LockModal';
import ServicesModal from './components/ServicesModal';
import useCompany from './useCompany';

export default function Company() {
  const {
    isLoading,
    doesApiHasError,
    companyData,
    handleTryAgain,
    isSomeCompanySelected,
    // userProfile,
    editCompanyModalShow,
    companyPhone,
    handleCompanyPhoneChange,
    companyName,
    handleCompanyNameChange,
    fantasyName,
    handleFantasyNameChange,
    cnpjPagto,
    handleCnpjPagtoChange,
    pagadorNFSeparada,
    setPagadorNFSeparada,
    employeesQty,
    handleEmployeesQtyChange,
    getErrorMessageByFieldName,
    setEditCompanyModalShow,
    editCompany,
    isReadyToEdit,
    setLockModalShow,
    lockCompany,
    lockModalShow,
    unlockAccess,
    servicesModalShow,
    setServicesModalShow,
    servicesList,
    selectedServices,
    setSelectedServices,
    confirmServices,
    canShowServicesButton,
    companyToken,
  } = useCompany();

  const {
    generalData, companyAddress, billingAddress, contactData
  } = companyData;
  const { isCustomer, canAccessFinancial } = useGetGeneralAppData();
  // const pagePermissions = permissions.find((x) => x.codPag === 1);

  return (
    <>
      <AppHeader isCompanySelectedDisabled={false} />
      <Sidebar active="Company" />
      <Loader isLoading={isLoading} />
      {!isLoading && !doesApiHasError && isSomeCompanySelected && (
        <>
          <Header
            setEditCompanyModalShow={setEditCompanyModalShow}
            setLockAccessModalShow={setLockModalShow}
            setServicesModalShow={setServicesModalShow}
            isUnlocked={companyData.isAccessUnlocked}
            canShowServicesButton={canShowServicesButton}
            canAccessFinancial={canAccessFinancial}
          />

          <Container>
            <Row xs={1} md={1} lg={1}>
              <Col>
                <OpacityAnimation delay={0.3}>
                  <GeneralDataCard generalData={generalData} companyToken={companyToken} />
                </OpacityAnimation>
              </Col>
            </Row>

            <Row xs={1} md={1} lg={2}>
              <Col>
                <OpacityAnimation delay={0.45}>
                  <CompanyAddressCard address={companyAddress} />
                </OpacityAnimation>
              </Col>

              <Col>
                <OpacityAnimation delay={0.6}>
                  <BillingAddressCard address={billingAddress} />
                </OpacityAnimation>
              </Col>
            </Row>

            <Row xs={1} md={1} lg={1}>
              <Col>
                <OpacityAnimation delay={0.3}>
                  <ContactDataCard contactData={contactData} />
                </OpacityAnimation>
              </Col>
            </Row>
          </Container>

          <EditModal
            editCompanyModalShow={editCompanyModalShow}
            companyName={companyName}
            handleCompanyNameChange={handleCompanyNameChange}
            fantasyName={fantasyName}
            handleFantasyNameChange={handleFantasyNameChange}
            cnpjPagto={cnpjPagto}
            handleCnpjPagtoChange={handleCnpjPagtoChange}
            pagadorNFSeparada={pagadorNFSeparada}
            setPagadorNFSeparada={setPagadorNFSeparada}
            cnpjCorretoOriginal={generalData?.cnpjCorretoOriginal}
            companyPhone={companyPhone}
            handleCompanyPhoneChange={handleCompanyPhoneChange}
            employeesQty={employeesQty}
            handleEmployeesQtyChange={handleEmployeesQtyChange}
            getErrorMessageByFieldName={getErrorMessageByFieldName}
            setEditCompanyModalShow={setEditCompanyModalShow}
            editCompany={editCompany}
            isReadyToEdit={isReadyToEdit}
          />

          <LockModal
            setLockModalShow={setLockModalShow}
            lockCompany={lockCompany}
            lockModalShow={lockModalShow}
            isUnlocked={companyData.isAccessUnlocked}
            unlockAccess={unlockAccess}
          />

          {!isCustomer && (
            <ServicesModal
              servicesModalShow={servicesModalShow}
              setServicesModalShow={setServicesModalShow}
              servicesList={servicesList}
              selectedServices={selectedServices}
              setSelectedServices={setSelectedServices}
              confirmServices={confirmServices}
            />
          )}
        </>
      )}

      {!isLoading && doesApiHasError && isSomeCompanySelected && (
        <NoData
          icon="sad"
          label={(
            <>
              Ocorreu um erro ao obter os dados da empresa.
              <button type="button" onClick={() => handleTryAgain}>Tentar Novamente</button>
            </>
          )}
        />
      )}

      {!isSomeCompanySelected && (
        <NoData
          icon="companyInterrogation"
          label={(
            <>
              Selecione uma empresa para visualizar seus dados.
            </>
          )}
        />
      )}
    </>
  );
}
